var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkillsImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 371,
    height: 366,
    viewBox: "0 0 371 366",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_88_7893)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 126,
    width: 160,
    height: 160,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 172.212C76 166.567 80.5554 162 86.2121 162H106.815C111.299 162 117.073 164.389 120.23 167.546L161.021 208.337C165 212.316 164.99 218.774 161.01 222.754L136.754 247.01C132.775 250.989 126.306 250.99 122.337 247.021L81.5462 206.23C78.3743 203.058 76 197.321 76 192.815V172.212ZM84 172.212V192.815C84 195.2 85.5321 198.902 87.2031 200.573L127.994 241.364C128.839 242.209 130.242 242.208 131.098 241.353L155.353 217.098C156.213 216.238 156.215 214.845 155.364 213.994L114.573 173.203C112.917 171.547 109.178 170 106.815 170H86.2121C84.9781 170 84 170.98 84 172.212ZM98 190C94.6863 190 92 187.314 92 184C92 180.686 94.6863 178 98 178C101.314 178 104 180.686 104 184C104 187.314 101.314 190 98 190Z",
    fill: "#0075D3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_88_7893)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 30,
    width: 160,
    height: 160,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.877 77.5012C178.636 76.5524 179.785 76 181 76H209C210.215 76 211.364 76.5524 212.123 77.5012L218.923 86H228.999C234.512 86 239 90.469 239 95.9822V134.018C239 139.528 234.523 144 229.007 144H160.988C155.474 144 151 139.528 151 134.018V95.9822C151 90.469 155.488 86 161.001 86H171.078L177.877 77.5012ZM182.923 84L176.123 92.4988C175.364 93.4476 174.215 94 173 94H161.001C159.899 94 159 94.895 159 95.9822V134.018C159 135.109 159.892 136 160.988 136H229.007C230.107 136 231 135.108 231 134.018V95.9822C231 94.895 230.101 94 228.999 94H217C215.785 94 214.636 93.4476 213.877 92.4988L207.077 84H182.923ZM195 130C185.059 130 177 121.941 177 112C177 102.059 185.059 94 195 94C204.941 94 213 102.059 213 112C213 121.941 204.941 130 195 130ZM195 122C200.523 122 205 117.523 205 112C205 106.477 200.523 102 195 102C189.477 102 185 106.477 185 112C185 117.523 189.477 122 195 122Z",
    fill: "#0075D3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_88_7893)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 156,
    width: 160,
    height: 160,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207 202.014C206.999 200.699 207.258 199.396 207.761 198.181C208.264 196.966 209.001 195.861 209.931 194.931C210.861 194.001 211.966 193.264 213.181 192.761C214.396 192.258 215.699 191.999 217.014 192H284.986C286.301 191.999 287.604 192.258 288.819 192.761C290.034 193.264 291.139 194.001 292.069 194.931C292.999 195.861 293.736 196.966 294.239 198.181C294.742 199.396 295.001 200.699 295 202.014V269.986C295.001 271.301 294.742 272.604 294.239 273.819C293.736 275.034 292.999 276.139 292.069 277.069C291.139 277.999 290.034 278.736 288.819 279.239C287.604 279.742 286.301 280.001 284.986 280H217.014C215.699 280.001 214.396 279.742 213.181 279.239C211.966 278.736 210.861 277.999 209.931 277.069C209.001 276.139 208.264 275.034 207.761 273.819C207.258 272.604 206.999 271.301 207 269.986V202.014ZM215 202.014V269.986C215 271.102 215.898 272 217.014 272H284.986C286.102 272 287 271.102 287 269.986V202.014C287 200.898 286.102 200 284.986 200H217.014C215.898 200 215 200.898 215 202.014ZM237.828 226.828L228.656 236L237.828 245.172C238.557 245.926 238.96 246.937 238.951 247.986C238.942 249.034 238.521 250.038 237.779 250.779C237.038 251.521 236.034 251.942 234.986 251.951C233.937 251.96 232.926 251.557 232.172 250.828L220.172 238.828C219.422 238.078 219.001 237.061 219.001 236C219.001 234.939 219.422 233.922 220.172 233.172L232.172 221.172C232.926 220.443 233.937 220.04 234.986 220.049C236.034 220.058 237.038 220.479 237.779 221.221C238.521 221.962 238.942 222.966 238.951 224.014C238.96 225.063 238.557 226.074 237.828 226.828ZM264.172 245.172L273.344 236L264.172 226.828C263.443 226.074 263.04 225.063 263.049 224.014C263.058 222.966 263.479 221.962 264.221 221.221C264.962 220.479 265.966 220.058 267.014 220.049C268.063 220.04 269.074 220.443 269.828 221.172L281.828 233.172C282.578 233.922 282.999 234.939 282.999 236C282.999 237.061 282.578 238.078 281.828 238.828L269.828 250.828C269.074 251.557 268.063 251.96 267.014 251.951C265.966 251.942 264.962 251.521 264.221 250.779C263.479 250.038 263.058 249.034 263.049 247.986C263.04 246.937 263.443 245.926 264.172 245.172ZM253.324 220.424C253.752 219.464 254.54 218.711 255.519 218.328C256.498 217.945 257.588 217.962 258.554 218.376C259.52 218.79 260.284 219.568 260.681 220.541C261.078 221.514 261.076 222.604 260.676 223.576L248.676 251.576C248.248 252.536 247.46 253.289 246.481 253.672C245.502 254.055 244.412 254.038 243.446 253.624C242.48 253.21 241.716 252.432 241.319 251.459C240.922 250.486 240.924 249.396 241.324 248.424L253.324 220.424Z",
    fill: "#0075D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_88_7893",
    x: 0,
    y: 96,
    width: 240,
    height: 240,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_88_7893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_88_7893",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_88_7893",
    x: 75,
    y: 0,
    width: 240,
    height: 240,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_88_7893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_88_7893",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_88_7893",
    x: 131,
    y: 126,
    width: 240,
    height: 240,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_88_7893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_88_7893",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsImages);
export default __webpack_public_path__ + "static/media/skillsImages.8f5a33ef77ac19cc7ce7d5b99556806b.svg";
export { ForwardRef as ReactComponent };